<template>
    <nav class="igp-trail">
        <ul class="igp-container">
            <li 
                v-for="(itemStatic, indexStatic) in trail.static" 
                :key="'static_' + indexStatic">
                <a :href="itemStatic.path">
                    <i v-if="indexStatic==0" class="fas fa-home" aria-hidden="true"> </i>
                    <span> {{ itemStatic.tag}}</span>
                </a> 
            </li>   
            <li 
                v-for="(itemDynamic, indexDynamic) in trail.dynamic" 
                :key="'dynamic_' + indexDynamic"
                :class="{active: (indexDynamic==trail.dynamic.length - 1)}">
                <router-link :to="itemDynamic.path" v-if="indexDynamic < trail.dynamic.length - 1">
                    <span> {{ itemDynamic.tag}}</span>
                </router-link> 
                <span v-else> {{ itemDynamic.tag}}</span>  
            </li>                
        </ul>
    </nav>
</template>
<script>
export default {
    props: {
        trail: {
            type: Object,
            default: () => {}
        }
    },
}
</script>